import { Molecule, wrap } from "AppReact";
import styled, { css } from "styled-components";
import { TextUnderline, Mr1 } from "wrappers";
import { SecondaryTextSm, Empty, RedTextSm } from "atoms";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { ArrowIconAnimation } from "./arrowAnimation";
import { ErrorSvg } from "components/icons";

const isMobile = getIsMobile();

const template = styled.label`
  ${({ isHovered }) => css`
    margin: 0;
    min-width: 250px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    background: #E3E3E3;
    border-radius: 8px;
    cursor: pointer;
    padding-left: 16px;
    &:hover {
      color: ${window?.settings?.primary_color ?? "#1DBD6B"};
    }

    @media only screen and (min-width: 768px) {
      justify-content: center;
      padding-left: unset;
    }
  `}
`;

export default Molecule({
  template,
  type: "dropFiles",
  atoms: [
    {
      component: Empty,
      name: "Icon",
      displayValue: ({ shouldAnimate, isError }) => {
        if(isError) return ErrorSvg({
          width: 26,
          height: 26,
        });
        return ArrowIconAnimation({ shouldAnimate })
      },
    },
    {
      component: wrap(SecondaryTextSm, TextUnderline),
      name: "UploadText",
      renderIf: ({ isError }) => !isError,
      displayValue: ({ text }) => text ?? "",
    },
    {
      component: SecondaryTextSm,
      name: "ErrorLabelText",
      renderIf: ({ isError }) => isError,
      displayValue: ({}) => "Upload Failed",
    },
    {
      component: wrap(SecondaryTextSm, TextUnderline),
      name: "ErrorText",
      renderIf: ({ isError }) => isError,
      displayValue: ({ }) => "Upload Again",
    },
  ],
});
